import { useStaticQuery, graphql } from "gatsby"

const useForSaleCommercialQuery = () => {
  const { allWpProperty } = useStaticQuery(graphql`
    query ForSaleCommercialQuery {
      allWpProperty(
        filter: {
          propertyListing: {
            status: {in: ["Available", "Conditional"]}, 
            hiddenListing: {eq: false}, 
            listedDate: {ne: ""}
          }, 
          propertyData: {
            type: {eq: "Commercial"}
          }
        }
        sort: {propertyListing: {listedDate: DESC}}
      )
      {
        nodes {
          ...PropertyCard
        }
      }
    }
  `)
  return allWpProperty.nodes || []
}

export default useForSaleCommercialQuery